import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ButtonModule } from 'primeng/button';
import { AiService } from 'src/app/service/ai.service';

@Component({
  selector: 'app-token-package-success',
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule, ButtonModule],
  templateUrl: './token-package-success.component.html',
  styleUrl: './token-package-success.component.css',
})
export class TokenPackageSuccessComponent implements OnInit, OnDestroy {
  status: 'polling' | 'success' | 'error' = 'polling';
  private timer: any;
  private attempts = 0;
  private readonly MAX_ATTEMPTS = 10;
  private readonly POLL_INTERVAL_MS = 3000;

  constructor(
    private router: Router,
    private aiService: AiService,
  ) {}

  ngOnInit(): void {
    this.poll();
  }

  private poll(): void {
    const expected = Number(sessionStorage.getItem('tokenPurchaseExpectedCredits') ?? 'NaN');
    this.timer = setInterval(() => {
      this.attempts++;
      this.aiService.getUsage().subscribe({
        next: (data) => {
          if (!Number.isNaN(expected) && data.credits_total >= expected) {
            this.clearTimer();
            this.status = 'success';
            const returnUrl = sessionStorage.getItem('tokenPurchaseReturnUrl') ?? '/my-garage';
            sessionStorage.removeItem('tokenPurchaseReturnUrl');
            sessionStorage.removeItem('tokenPurchaseExpectedCredits');
            setTimeout(() => this.router.navigateByUrl(returnUrl), 1500);
          } else if (this.attempts >= this.MAX_ATTEMPTS) {
            this.clearTimer();
            this.status = 'error';
          }
        },
        error: () => {
          if (this.attempts >= this.MAX_ATTEMPTS) {
            this.clearTimer();
            this.status = 'error';
          }
        },
      });
    }, this.POLL_INTERVAL_MS);
  }

  private clearTimer(): void {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  goToDashboard(): void {
    const returnUrl = sessionStorage.getItem('tokenPurchaseReturnUrl') ?? '/my-garage';
    sessionStorage.removeItem('tokenPurchaseReturnUrl');
    sessionStorage.removeItem('tokenPurchaseExpectedCredits');
    this.router.navigateByUrl(returnUrl);
  }

  ngOnDestroy(): void {
    this.clearTimer();
  }
}
